<script setup lang="ts">
import { Button, Modal } from '@albank/vue-ui-kit';
import { inject, ref } from 'vue'

const view = inject("view", "mobile")
const modal = ref<boolean>(false)

const reference = ref()

defineExpose({ reference })

</script>

<template>
  <section ref="reference" class="home screen">
    <div 
      v-motion class="home__content" 
      :initial="{opacity: 0, y: 300}"
      :visibleOnce="{opacity: 1, y: 0, transition: {duration: 1500}}"
    >
      <h1>Ваш банк <br />в мобильном <br v-if="view == 'mobile'" /> приложении</h1>
      <p>Доступен для устройств на iOS и Android</p>
      <Button class="button" @click="() => {modal = true}" >Скачать приложение</Button>  
    </div>
    <img  
      v-motion 
      :initial="{opacity: 0, scale: 0.8}"
      :visibleOnce="{
        opacity: 1, scale: 1, 
        transition: {
          duration: 1500,
          delay: 400
        }
      }"
      class="home__image"
      src="/assets/images/home.png" 
      alt="Приложение" 
    />    
    <Transition name="modal">
      <Modal
        class="modal"
        :is-open="modal"
        :controls-config="{
          leftBtn: { hidden: true },
          rightBtn: { hidden: true },
          closeBtn: { hidden: false }
        }"
        @close-btn-click="() => {modal = false}"
      >
        <h3>Скачать приложение <br /> «АЭБ Онлайн»</h3>
        <p>Наведите камеру телефона на QR-код <br />и скачайте приложение</p>
        <img class="qr" src="/assets/images/qr-code.png" alt="QR">      
      
        <div class="links">
          <a href="https://apps.apple.com/ru/app/%D0%B0%D1%8D%D0%B1-%D0%BE%D0%BD%D0%BB%D0%B0%D0%B9%D0%BD-2-0/id1278796871">
            <img src="/assets/images/app-store.png" alt="App store">
          </a>
          <a href="https://play.google.com/store/apps/details?id=ru.albank.online.aebit&hl=ru">
            <img src="/assets/images/google-play.png" alt="Google play">
          </a>
          <a href="https://www.rustore.ru/catalog/app/ru.albank.online.aebit">
            <img src="/assets/images/ru-store.png" alt="Ru store">
          </a>
          <a href="https://appgallery.huawei.com/#/app/C104494399">
            <img src="/assets/images/app-gallery.png" alt="App gallery">
          </a>
        </div>
      </Modal>
    </Transition>
  </section>
</template>


<style lang="scss">
.home {
  overflow-x: hidden;
  height: calc(100vh - 84px);

  @media screen and (max-width: 800px) {
    justify-content: space-around;
  }

  &__content {
    z-index: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  h1 {
    margin-top: 60px;
    font-weight: 500;
    text-align: center;
    font-size: var(--font-size-xxxl);

    @media screen and (max-height: 800px) {
      margin-top: 40px;
      font-size: var(--font-size-xl);
    }

    @media screen and (max-width: 800px) {
      margin-top: 40px;
      font-size: var(--font-size-lm);
    }
  }

  p {
    margin-top: 16px;
    text-align: center;
    padding: 0 10%;
    font-size: var(--font-size-md);
  }

  .button {
    margin-top: 32px;
    @media screen and (max-width: 800px) {
      margin-top: 16px;
    }
  }

  &__image {
    bottom: 0;
    width: 80vw;
    max-height: 510px;
    max-width: 1024px;
    position: absolute;
    
    @media screen and (max-height: 800px) {
      max-height: 400px;
    }

    @media screen and (max-width: 800px) {
      width: 160%;
      position: relative;
    }
  }
}

.modal {
  z-index: 100;
  display: flex;
  flex-direction: column;

  .aeb-modal__window--S {
    gap: 20px;
    padding: 40px;
    max-width: 536px;

    @media screen and (max-width: 800px) {
        max-width: 90vw;
    }

    h3 {
      text-align: center;
      font-size: var(--font-size-l);

      br {
        display: none;
      }

      @media screen and (max-width: 800px) {
        font-size: var(--font-size-s);

        br {
          display: block;
        }
      }
    }

    p {
      margin: 0;
      padding: 0;
      font-size: var(--font-size-s);
      color: var(--color-mono-500);

      @media screen and (max-width: 800px) {
        font-size: var(--font-size-xxs);
      }
    }

    .qr {
      max-width: 180px;

      @media screen and (max-width: 800px) {
        max-width: 120px;
      }
    }

    .links {
      width: 100%;
      gap: 20px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      justify-content: center;

      img {
        max-width: 100%;
      }

      @media screen and (max-width: 800px) {
        gap: 12px;
        margin-top: 0px;
        max-width: 120px;
      }

      @media screen and (max-height: 600px) {
        max-width: 240px;
        flex-direction: row;

        a {
          max-width: 45%;
        }
      }

    }
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
  will-change: opacity;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
